/**
 * Interrompe il flusso con un solo messaggio (DESIGN-TOKENS §4). Il testo resta ink:
 * il rosso di errore/rischio sta solo sul bordo e sull'icona, mai sulle parole.
 * Il contenuto arriva dalle regole safety (lane D): questo componente non inventa
 * numeri di emergenza ne indicazioni sanitarie.
 */
export type SafetyBannerProps = {
  message: string
  actionLabel?: string
  onAction?: () => void
}

export function SafetyBanner({ message, actionLabel, onAction }: SafetyBannerProps) {
  return (
    <div
      role="alert"
      className="flex flex-col gap-3 rounded-field border-[3px] border-error bg-surface px-[20px] py-[18px] text-ink"
    >
      <div className="flex items-start gap-3">
        <AlertIcon />
        <p className="text-body font-bold">{message}</p>
      </div>
      {actionLabel && (
        <button
          type="button"
          onClick={onAction}
          className="min-h-control w-full rounded-control border-2 border-ink bg-surface px-3 text-secondary font-bold text-ink"
        >
          {actionLabel}
        </button>
      )}
    </div>
  )
}

function AlertIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="mt-[0.2em] h-[1.2em] w-[1.2em] shrink-0 text-error"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3l10 18H2L12 3z" />
      <path d="M12 10v5" />
      <path d="M12 18.5v.01" />
    </svg>
  )
}
